import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import Link from "@material-ui/core/Link";
import moment from "moment";

import { useStyles } from "./DashboardFees.css";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class DashboardFees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billList: [],
    };
  }

  componentDidMount() {
    this.getDashboardFees();
  }

  getDashboardFees = async () => {
    try {
      const getResponse = await Axios.get(`${url}/api/student-fees`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      this.setState({ billList: getResponse.data.studentFees });
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getDashboardFees();
      }
    }
  };

  render() {
    const { classes } = this.props;
    let month = moment(new Date()).format("MMMM");
    let initalFilter = this.state.billList
      .map((bill) =>
        bill.fees.filter(
          (fee) => fee.month.toLowerCase().indexOf(month.toLowerCase()) !== -1
        )
      )
      .map((data) => data);
    let filtered = initalFilter.filter((data) => data.length !== 0);
    return (
      <div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
            <Paper className={classes.paper}>
              <div>Current Month:- {month}</div>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Total Students</b>
                <div>{this.props.totalStudents}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Bill Sent To</b>
                <div> {filtered.length}</div>
              </ListItem>
              <div>
                {this.props.totalStudents !== filtered.length ? (
                  <div style={{ textAlign: "center" }}>
                    <div>This month's bill is not sent to everybody.</div>
                    <Link href="/administration/Fees-Manage">Manage Bill</Link>
                  </div>
                ) : (
                  <Link href="/administration/Fees-Manage">Manage Bill</Link>
                )}
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(DashboardFees));
